module.exports = __webpack_public_path__ + "img/gallery_image-2.135ed01.jpg";